<div class="header">
  <!-- Filters -->
  <div class="filter-bar" [formGroup]="filterForm">
    <mat-form-field appearance="outline" id="txtDocumentName" class="filter-form-field">
      <input matInput class="lo_sensitive" placeholder="Search by file name" formControlName="searchTerm"/>
      <mat-icon matPrefix class="magnify-icon notranslate">search</mat-icon>
      <button mat-icon-button matSuffix *ngIf="filterForm.get('searchTerm').value"
              (click)="filterForm.get('searchTerm').setValue('')">
        <mat-icon class="notranslate">close</mat-icon>
      </button>
    </mat-form-field>
    <div class="timespan-filter-wrapper">
      <label for="ddlDocumentsTimespan" class="text-input-label documents-timespan-label">Show files from</label>
      <mat-form-field appearance="outline" class="remove-error-place documents-timespan-select">
        <mat-select id="ddlDocumentsTimespan" formControlName="period">
          <mat-option [value]="0">
            All time
          </mat-option>
          <mat-option [value]="1">
            Current quarter
          </mat-option>
          <mat-option [value]="2">
            Current year
          </mat-option>
          <mat-option [value]="3">
            Previous year
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Sorted By -->
    <div class="order-wrapper">
      <label for="ddlDocumentsOrder" class="text-input-label order-documents-label">Sort By</label>
      <mat-form-field appearance="outline" class="remove-error-place order-documents-select">
        <mat-select id="ddlDocumentsOrder" formControlName="order">
          <mat-option [value]="OrderDocuments.dateAsc">
            Time Added: Older first
          </mat-option>
          <mat-option [value]="OrderDocuments.dateDesc">
            Time Added: Newer first
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <button type="button" (click)="openDialogToUploadFile()" [disabled]="isViewingAsInvestor || !(investedInHolding$ | async)" mat-stroked-button color="primary"
          class="file-upload covercy-wired-button">
    <mat-icon class="open_icon notranslate">add</mat-icon>
    File Upload
  </button>
</div>

<!-- Documents list -->
<ul class="documents-list" *ngIf="documents$ | async as documents">
  <ng-container *ngIf="(isLoader$ | async) == false">
    <li class="document-list-item" *ngFor="let document of documents" matRipple [matRippleTrigger]="rippleTrigger">

      <!-- File information (clickable for preview)  -->
      <a class="preview-link" (click)="previewDocument(document)" #rippleTrigger [matTooltip]="document.displayName" matTooltipClass="terra-tooltip-wide" matTooltipPosition="above">
        <mat-icon *ngIf="document.storageObjectType === StorageObjectType.File" class="document-icon notranslate"
                  [svgIcon]="document.metaFileLink | mediaFileIcon">
        </mat-icon>
        <div class="file-details">
        <span class="document-name lo_sensitive">
          {{ document.displayName | truncate : 35 }}.{{ document.extension }}
        </span>
          <span class="document-date">
          {{ document.createTimestamp | date:'MMM d, y, h:mm:ss a' }}, {{ document.metaFileLink?.sizeB | fileSize }}
        </span>
        </div>
      </a>

      <!-- Options menu - mobile -->
      <button mat-icon-button (click)="showFileOptionsMenu(document)" class="file-options-toggle-mobile">
        <mat-icon class="notranslate">more_vert</mat-icon>
      </button>

      <!-- Menu trigger - desktop -->
      <button mat-icon-button [matMenuTriggerFor]="desktopOptionsMenu" class="file-options-toggle-desktop">
        <mat-icon class="notranslate">more_vert</mat-icon>
      </button>
      <!-- Menu panel - desktop (hidden until opened) -->
      <mat-menu #desktopOptionsMenu="matMenu">
        <p class="file-name-in-menus"> {{ document.displayName }}.{{ document.extension }} </p>
        <!-- View button -->
        <button mat-menu-item (click)="previewDocument(document)">
          <mat-icon class="notranslate">visibility</mat-icon>
          <span>View</span>
        </button>
        <!-- Download button -->
        <button mat-menu-item (click)="downloadDocument(document)">
          <mat-icon class="notranslate">get_app</mat-icon>
          <span>Download</span>
        </button>
        <!-- Delete button -->
        <ng-container *ngIf="hasDeleteAccess(document) | async">
          <button mat-menu-item (click)="delete(document)">
            <mat-icon class="notranslate">delete</mat-icon>
            <span>Delete</span>
          </button>
        </ng-container>
      </mat-menu>
    </li>

    <!-- Empty state -->
    <li class="empty-state" *ngIf="!documents || !documents.length">
      <p class="no-files-main">No files to display.</p>
      <p class="no-files-description">Try changing the filters above, or it could be that no files were shared with you
        yet.</p>
    </li>
  </ng-container>
</ul>

<terra-loader class="loader" *ngIf="(isLoader$ | async) == true"></terra-loader>
